import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Badge } from 'react-bootstrap';
import { FaClock, FaUser, FaArrowRight } from 'react-icons/fa6';

export default function PostCard({ post, featured = false }) {
  if (!post) return null;

  const dateObj = new Date(post.publishedAt);
  const formattedDate = dateObj.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  if (featured) {
    return (
      <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4 bg-white transition-all hover-shadow">
        <div className="row g-0 align-items-center">
          <div className="col-lg-6 position-relative" style={{ minHeight: '320px' }}>
            <Link href={`/blog/${post.slug}`} className="d-block w-100 h-100 position-relative">
              <img
                src={post.coverImage || 'https://images.aboutcar.com.br/blog/defaults/dicas-1.jpg'}
                alt={post.title}
                className="w-100 h-100"
                style={{ objectFit: 'cover', minHeight: '320px', maxHeight: '420px' }}
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src = 'https://images.aboutcar.com.br/blog/defaults/dicas-1.jpg';
                }}
              />
            </Link>
          </div>
          <div className="col-lg-6 p-4 p-md-5 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex align-items-center gap-2 mb-3">
                <span className="badge bg-primary-subtle text-primary fw-semibold px-3 py-2 rounded-pill fs-7">
                  {post.category?.name || 'Artigo'}
                </span>
                <span className="text-muted small d-inline-flex align-items-center gap-1">
                  <FaClock size={12} />
                  {post.readTime}
                </span>
              </div>
              <h2 className="card-title fw-bold fs-3 text-dark mb-3 lh-sm">
                <Link href={`/blog/${post.slug}`} className="text-decoration-none text-dark hover-primary">
                  {post.title}
                </Link>
              </h2>
              <p className="card-text text-secondary fs-6 mb-4 line-clamp-3">
                {post.excerpt}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between pt-3 border-top">
              <div className="d-flex align-items-center gap-2 text-muted small">
                <div className="bg-light rounded-circle p-2 d-flex align-items-center justify-content-center text-primary" style={{ width: 34, height: 34 }}>
                  <FaUser size={13} />
                </div>
                <div>
                  <span className="d-block fw-semibold text-dark">{post.author?.name || 'AboutCar'}</span>
                  <span className="text-muted fs-8">{formattedDate}</span>
                </div>
              </div>
              <Link href={`/blog/${post.slug}`} className="btn btn-outline-primary rounded-pill px-4 fw-semibold btn-sm d-inline-flex align-items-center gap-2">
                Ler Artigo
                <FaArrowRight size={12} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden bg-white transition-all hover-shadow">
      <Link href={`/blog/${post.slug}`} className="position-relative overflow-hidden d-block" style={{ height: '200px' }}>
        <img
          src={post.coverImage || 'https://images.aboutcar.com.br/blog/defaults/dicas-1.jpg'}
          alt={post.title}
          className="w-100 h-100 transition-all hover-scale"
          style={{ objectFit: 'cover' }}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = 'https://images.aboutcar.com.br/blog/defaults/dicas-1.jpg';
          }}
        />
        <span className="position-absolute top-0 start-0 m-3 badge bg-primary text-white fw-semibold px-3 py-2 rounded-pill shadow-sm fs-7">
          {post.category?.name || 'Dicas'}
        </span>
      </Link>
      <div className="card-body p-4 d-flex flex-column justify-content-between">
        <div>
          <div className="d-flex align-items-center justify-content-between text-muted small mb-2">
            <span>{formattedDate}</span>
            <span className="d-inline-flex align-items-center gap-1">
              <FaClock size={11} />
              {post.readTime}
            </span>
          </div>
          <h3 className="card-title fw-bold fs-5 text-dark mb-2 line-clamp-2 lh-snug">
            <Link href={`/blog/${post.slug}`} className="text-decoration-none text-dark hover-primary">
              {post.title}
            </Link>
          </h3>
          <p className="card-text text-secondary small line-clamp-3 mb-3">
            {post.excerpt}
          </p>
        </div>
        <div className="d-flex align-items-center justify-content-between pt-3 border-top mt-auto">
          <span className="text-muted small fw-medium">
            Por {post.author?.name || 'AboutCar'}
          </span>
          <Link href={`/blog/${post.slug}`} className="text-primary fw-semibold small text-decoration-none d-inline-flex align-items-center gap-1 hover-arrow">
            Ler mais <FaArrowRight size={11} />
          </Link>
        </div>
      </div>
    </div>
  );
}
